<script>
export default {
  props: {
    number: { type: String, default: '' },
  },
  mounted() {
    if (!this.number) return;

    window.postMessage({ type: 'DIAL_NUMBER', number: this.number }, '*');

    setTimeout(() => window.close(), 3000);
  },
};
</script>

<template>
  <div class="flex items-center justify-center h-full">
    <p v-if="number" class="text-lg text-slate-700 dark:text-slate-200">
      {{ $t('DIAL_REDIRECT.DIALING', { number }) }}
    </p>
    <p v-else class="text-lg text-red-500">
      {{ $t('DIAL_REDIRECT.NO_NUMBER') }}
    </p>
  </div>
</template>
